export function exportToCsv(filename: string, rows: any[], columns?: string[], labels?: string[]): void {
  if (!rows || !rows.length) {
    return;
  }

  const headers = columns || Object.keys(rows[0]);

  const headerLabels = labels && labels.length === headers.length
    ? labels
    : headers;

  const sanitize = (value: any): string => (value ?? '').toString().replace(/\u00A0/g, ' ');

  let csvContent = headerLabels.map(sanitize).join(';') + '\n';

  rows.forEach(row => {
    const values = headers.map(header => {
      const cellValue = sanitize(row[header]);
      if (cellValue.includes(';') || cellValue.includes('"')) {
        return `"${cellValue.replace(/"/g, '""')}"`;
      }
      return cellValue;
    });

    csvContent += values.join(';') + '\n';
  });

  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  if ((navigator as any).msSaveBlob) {
    (navigator as any).msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');

    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}



export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | boolean | null | undefined;
}

function escapeCsv(value: string): string {
  const needsQuotes = /[",\n\r]/.test(value);
  const escaped = value.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

function toText(value: string | number | boolean | null | undefined): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return value;
}

export function buildCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const headerLine = columns.map(c => escapeCsv(c.header)).join(',');
  const lines = rows.map(row =>
    columns.map(c => escapeCsv(toText(c.value(row)))).join(',')
  );
  return [headerLine, ...lines].join('\r\n');
}